<template>
  <div class="content">
    <div class="logo">
      <img src="@/assets/images/logo.png" />
    </div>
    <div class="cashierDesk">
      <div>Checkout</div>
      <div>收银台</div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.content {
  height: 100%;
  box-shadow: 0 8px 4px -4px rgba(62, 156, 244, 0.3);
  display: flex;
  align-items: center;
  padding: 0 350px;
  .logo {
    position: relative;
    img {
      height: 70px;
      margin-right: 5px;
    }
  }
  .logo::after {
    position: absolute;
    content: "";
    height: calc(100% - 20px);
    top: 10px;
    bottom: 10px;
    border-right: 2px solid #d2d2d2;
  }
  .cashierDesk {
    margin-left: 10px;
    font-weight: bold;
    > div:first-child {
      font-size: 14px;
      color: rgb(62, 156, 244);
    }
    > div:last-child {
      font-size: 20px;
    }
  }
}
</style>